// Corporate Performance — ดูภาพรวมเวลาตอบ inbox ของทุกเพจในโปรเจกต์เดียวกัน
//
// โปรเจกต์ = กลุ่มเพจที่ตั้งไว้ฝั่ง Inbox Center (เขาเป็นเจ้าของข้อมูลนี้)
// เราไม่เก็บสำเนา แค่ดึงมาให้เลือก แล้วส่ง ?project= กลับไปให้เขาคิดตัวเลขให้
import { inboxAuthHeaders } from "@features/inbox/api/inbox-api";
import type { InboxAnalytics } from "@features/overview/api/upstream-types";
import { api } from "@shared/api/client";

export type InboxProject = {
  id: string;
  name: string;
  description?: string;
  pageIds: string[];
  createdAt?: string;
};

export const corporateKeys = {
  projects: ["corporate", "projects"] as const,
  perf: (projectId: string, days: number) => ["corporate", "perf", projectId, days] as const,
};

function authOrThrow() {
  const headers = inboxAuthHeaders();
  if (!headers) throw new Error("ยังไม่ได้เข้าสู่ระบบ Wazzup");
  return headers;
}

const tzMinutes = () => String(-new Date().getTimezoneOffset());

export async function fetchProjects(): Promise<InboxProject[]> {
  const { data } = await api.get<InboxProject[]>("/inbox/projects", { headers: authOrThrow() });
  return Array.isArray(data) ? data : [];
}

/** ตัวเลขต่อเพจของทั้งโปรเจกต์ในช่วงวันที่เลือก (perPage มี avgHumanMs = เวลาตอบเฉลี่ย) */
export async function fetchProjectPerformance(
  projectId: string,
  days: number,
): Promise<InboxAnalytics> {
  const to = new Date();
  const from = new Date(to.getTime() - (days - 1) * 86400000);
  const day = (d: Date) => d.toISOString().slice(0, 10);
  const { data } = await api.get<InboxAnalytics>("/inbox/analytics", {
    headers: authOrThrow(),
    params: { project: projectId, from: day(from), to: day(to), tz: tzMinutes() },
  });
  return data;
}
